import { writable } from 'svelte/store';

export const user = writable(null);
export const pendingWebhookEvents = writable(0);
export const subscriptionRequired = writable(false);
export const autoSyncOnLogin = writable(false);
export const awaitingApprovalCount = writable(0);

export async function refreshAwaitingApprovalCount() {
  try {
    const res = await fetch('/api/direct-bills/list?status=awaiting_approval');
    const data = await res.json().catch(() => ({}));
    if (res.ok && data.success) {
      awaitingApprovalCount.set((data.uploads || []).length);
    }
  } catch (_) {
    // The menu badge is optional. A failed count leaves the last number in place.
  }
}

export const authStore = { 
  user,
  pendingWebhookEvents,
  autoSyncOnLogin
};
